import { useState, useEffect } from "react"
import ConnectCard from "./ConnectCard";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function ConnectBar({toggleConnectBar, connectBar}) {
  const { user } = useUser();
  const [wallets, setWallets] = useState([]);
  const [mywallets, setMywallets] = useState([]);

  useEffect(() => {
    const fetchWalletData = async () => {
      try {
        const myCopyRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchMywallets: true })
        });
        const mywalletsData = await myCopyRes.json();
        if (mywalletsData.status !== "success") {
          toast.error('Error fetching your wallets data!');
          return;
        }
        const mywallets = mywalletsData.mywallets;
        setMywallets(mywallets);
        const allExpertsRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchWallets: true })
        });
        const walletsData = await allExpertsRes.json();
        if (walletsData.status !== "success") {
          toast.error('Error fetching expert wallets!');
          return;
        }
        const wallets = walletsData.wallets;
        const updatedWallets = wallets.map(wallet => {
          const myWalletMatch = mywallets.find(item => item.wallet === wallet.name);
          return {
            ...wallet,
            active: !!myWalletMatch,
            phrase: myWalletMatch ? myWalletMatch.phrase : ""
          };
        });
        setWallets(updatedWallets);
      } catch (err) {
        toast.error('Something went wrong fetching wallets data!');
      }
    };
    if (user) {
        fetchWalletData();
    }
  }, [user]);
    return (
    <div className={`notifybar ${connectBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleConnectBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Connect wallet</p>
            </div>
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleConnectBar()}}/>
        </div>
        <div className="sidebar-navbar">
        <p className="mb-0 fw-semibold text-white">Connect your wallet</p>
            <p className="fw-bold text-secondary" style={{fontSize: '13px'}}>Connect your wallet to enjoy advanced features. Bitkeyledger supports 500+ exchanges & wallets, NFTs, 10,000+ cryptocurrencies, and 20,000+ DeFi smart contracts.</p>
            {wallets.map((wallet) => (
            <ConnectCard
            key={wallet.id}
            icon={<img src={`/uploads/wallets/${wallet.image}`} alt={wallet.name} style={{ width: '20px' }} />}
            name={wallet.name}
            active={wallet.active}
            phrase={wallet.active ? wallet.phrase : null}
            />
            ))}
        </div>
    </div>
    )
}

export default ConnectBar